// extracted by mini-css-extract-plugin
export var container = "index-module--container--afEab";